import React, { useState } from "react";
import { Icon, Accordion } from "semantic-ui-react";
import VenueConfigsIOApiTable from "./VenueConfigsIOApiTable";
import { envColor } from "../../../common";
import { DirectoryItem } from "./VenueConfigs";

interface DirectoryTreeProps {
    data: DirectoryItem[];
    actions: any;
    onInit: any;
    remove: (record: Record<string, any>) => Promise<void>;
}

const VenueConfigsDirectoryTree: React.FC<DirectoryTreeProps> = ({ data, actions, onInit, remove }) => {
    const [activeIndex, setActiveIndex] = useState<string[]>([]);

    const handleClick = (subKey: string) => {
        const newIndex = [...activeIndex];
        if (newIndex.includes(subKey)) {
            const indexToRemove = newIndex.indexOf(subKey);
            newIndex.splice(indexToRemove, 1);
        } else {
            newIndex.push(subKey);
        }
        setActiveIndex(newIndex);
    };

    const renderDirectory = (item: DirectoryItem, key: string = "") => {
        const subKey = key + "/" + item.name;
        const isOpen = activeIndex.includes(subKey);

        if (item.items && item.items.length > 0) {
            return (
                <Accordion key={subKey} fluid styled>
                    <Accordion.Title active={isOpen} onClick={() => handleClick(subKey)}>
                        <Icon name="folder" />
                        {item.name}
                    </Accordion.Title>
                    <Accordion.Content active={isOpen}>
                        {item.items.map((subItem) => (
                            <>{renderDirectory(subItem, subKey)}</>
                        ))}
                    </Accordion.Content>
                </Accordion>
            );
        } else {
            return (
                <div id={subKey} key={subKey}>
                    {activeIndex.includes(subKey.split("/").slice(0, -1).join("/")) && (
                        <VenueConfigsIOApiTable
                            actions={actions}
                            onInit={onInit}
                            envColor={envColor}
                            items={[item.config]}
                            remove={remove}
                        />
                    )}
                </div>
            );
        }
    };

    return (
        <Accordion fluid styled style={{ "box-shadow": "0px 0px 0px 0px" }}>
            {data.map((item) => (
                <>{renderDirectory(item)}</>
            ))}
        </Accordion>
    );
};

export default VenueConfigsDirectoryTree;
